import './Home.css'

const Home = (props) => {
  return (
    <>
      {props.children}
    </>
  )
}

export default Home
